import { Observable } from 'rxjs/Rx';
import { PointInterest } from './../objects/data-management';
import { Storage } from '@ionic/storage';
import { CallNumber } from '@ionic-native/call-number';
import {Injectable} from '@angular/core';
import 'rxjs/add/operator/map';
import {Http, Headers} from '@angular/http';
import {GlobalService} from "./global.config";
import {RealTimeRecord, Group} from "../objects/real-time";
import {createAuthorizationHeader} from "../utils/headers";
import {User} from '../objects/real-time';
import {Events } from 'ionic-angular';


@Injectable()
export class RealTimeService {

    currentuser:User;
    dns:string;
    constructor(private _http: Http,private storage:Storage,private globalService : GlobalService,public events: Events) {
        this.currentuser=JSON.parse(localStorage.getItem('currentuser'));
      this.events.subscribe('dns', (dns) => {
     //console.log(path);
     if (dns){
        this.dns = dns;
     }
   });
      console.log(this.dns);
        
    }

    getRealTimeRecord(deviceId: number): Observable<RealTimeRecord> {
        let headers = new Headers({'Accept': 'application/json'});
        headers.append('Authorization', this.currentuser.token);
        // ici il faut recuperer utilisateur courant !!!!
        // il faut dabord lors de authen => tu gard utilisteur sur le storage pour que tu puise le recuperer ici
        console.log(this.dns);
        return this._http.get(this.dns + 'realTimeRecords/' + deviceId, {headers: headers}).map(res => res.json());

    }

    getAllPois(): Observable<PointInterest[]> {
        let headers = new Headers({'Accept': 'application/json'});
        headers.append('Authorization', this.currentuser.token);
        return this._http.get(this.dns + 'pointInterests/dtos', {headers: headers}).map(res => res.json());
    }

    getAllRealTimeRecords(): Observable<RealTimeRecord[]> {
        let headers = new Headers({'Accept': 'application/json'});
        let parms = "";
        headers.append('Authorization', this.currentuser.token);
       
        if (!this.currentuser.isRoot) {
            parms = '?id=' + this.currentuser.id;
        }
        return this._http.get(this.dns + 'realTimeRecords'+ parms, {headers: headers}).map(res => res.json());
    }

    getAllGroups(keyword: string): Observable<Group[]> {
        let headers = new Headers({'Accept': 'application/json'});
        headers.append('Authorization', this.currentuser.token);
        let parms = "";
        if (!this.currentuser.isRoot) {
            parms = '&id=' + this.currentuser.id;
        }
        return this._http.get(this.dns + 'groupes/details?keyword=' + keyword + parms, {headers: headers}).map(res => res.json());       
    }

    getGroupMini():Observable<any>{
        let headers = new Headers({'Accept': 'application/json'});
        headers.append('Authorization', this.currentuser.token);
        let parms = "";
        if (!this.currentuser.isRoot) {
            parms = '&id=' + this.currentuser.id;
        }
        return this._http.get(this.dns + 'groupes/minifyGroups?'+parms, {headers: headers}).map(res => res.json());       

    }
    findVehiculesByGroupsId(idgroup:any,size:any,page:any):Observable<any>{
        let headers = new Headers({'Accept': 'application/json'});
        headers.append('Authorization', this.currentuser.token);
        let parms = "";
        if (!this.currentuser.isRoot) {
            parms = '&id=' + this.currentuser.id;
        } 
        return this._http.get(this.dns + 'vehicules/paginate/by/'+idgroup+'?size='+size+'&page='+page, {headers: headers}).map(res => res.json());       
    }
    getCurrentPath(deviceId: number): Observable<any> {
        let headers = new Headers({'Accept': 'application/json'});
        headers.append('Authorization', this.currentuser.token);
        return this._http.post(this.dns + 'paths/currentPath/' + deviceId,null,  {headers: headers}).map(res => res.json());
    }

    startEngine(idBoitier: number,authData:any): Observable<Boolean> {
        
        let body = `username=${authData.username}&password=${authData.password}`;
       
        let headers = new Headers({'Content-Type': 'application/x-www-form-urlencoded'});
        headers.append('Authorization', this.currentuser.token);
        return this._http.post(this.dns + 'engine/startMobile/' + idBoitier, body, {headers: headers}).map(res => res.json());
    }
    stopEngine(idBoitier: number,authData:any): Observable<Boolean> {

        let body = `username=${authData.username}&password=${authData.password}`;

        let headers = new Headers({'Content-Type': 'application/x-www-form-urlencoded'});
        headers.append('Authorization', this.currentuser.token);
        return this._http.post(this.dns + 'engine/stopMobile/' + idBoitier, body, {headers: headers}).map(res => res.json());
    }
    
}


// WEBPACK FOOTER //
// ./src/providers/real-time.service.ts